import { RenderMode, ServerRoute } from '@angular/ssr';

export const serverRoutes: ServerRoute[] = [
  // Authenticated app pages — client-side render (need auth/localStorage)
  { path: 'app/**', renderMode: RenderMode.Client },
  { path: 'create-family-space', renderMode: RenderMode.Client },
  // Auth pages — client render (login state depends on browser)
  { path: 'login', renderMode: RenderMode.Client },
  { path: 'register', renderMode: RenderMode.Client },
  { path: 'forgot-password', renderMode: RenderMode.Client },
  { path: 'reset-password', renderMode: RenderMode.Client },
  // All public/marketing pages — prerendered for SEO
  { path: '**', renderMode: RenderMode.Prerender },
];
